import { createContext } from 'react';
import { useContextParams } from '@core/params/context';
import { useCreateVideoWrapper } from '@embed/components/VideoPlayer/hooks/useCreateVideoWrapper';
import { useStore } from '@embed/components/VideoPlayer/Player3/store';
export const VideoElContext = createContext(undefined);
/**
 * Provide video wrapper element built from video and params from store
 * @param param0
 * @returns
 */
const VideoElProviderFromStore = ({ children, isStoryblock, }) => {
    const params = useContextParams();
    const video = useStore((state) => state.video);
    const element = useCreateVideoWrapper({
        isStoryblock,
        params,
        video,
    });
    return (<VideoElContext.Provider value={element}>
      {element ? children : null}
    </VideoElContext.Provider>);
};
/**
 * Provide video wrapper element built from video and params from store
 * or from `element` dependency injection (for tests).
 */
export const VideoElProvider = ({ element, isStoryblock, children }) => {
    return element ? (<VideoElContext.Provider value={element}>
      {children}
    </VideoElContext.Provider>) : (<VideoElProviderFromStore isStoryblock={isStoryblock}>
      {children}
    </VideoElProviderFromStore>);
};
